<template>
  <div style="background-color: white">
    <app-loader v-if="loading"></app-loader>
    <ChatComponent />
    <div v-if="dataLoaded">
      <div class="container-header-detalle ps-md-12 ps-0 pb-0">
        <v-row no-gutters class="pb-0 d-flex justify-start">
          <v-col cols="12" lg="6" md="6" sm="6" class="mt-lg-10 mt-0">
            <v-row no-gutters>
              <v-col cols="12" sm="12" md="12" class="componente-posicion px-0">
                <p
                  :class="
                    $vuetify.breakpoint.lgAndUp
                      ? 'text-h6 mb-7'
                      : 'text-h6 mb-3'
                  "
                  class="ma-3 primary--text"
                >
                  {{
                    capitalizeFirstLetter(
                      DetallePuesto?.solicitud.UnidadOrganizativa?.estable?.nombre
                    )
                  }}
                </p>
                <p
                  :class="
                    $vuetify.breakpoint.lgAndUp
                      ? 'text-h6 mb-7'
                      : 'text-h6 mb-3'
                  "
                  class="ma-3 primary--text"
                >
                  {{
                    capitalizeFirstLetter(
                      DetallePuesto?.solicitud.UnidadOrganizativa?.nombre
                    )
                  }}
                </p>
                <p
                  :style="
                    $vuetify.breakpoint.lgAndUp ? 'line-height: 1.1;' : ''
                  "
                  :class="$vuetify.breakpoint.lgAndUp ? 'text-h3' : 'text-h6'"
                  class="ma-2 mb-3 primary--text museo-text bolder-text"
                  style="
                    font-weight: bolder;
                    text-transform: capitalize;
                  "
                >
                  {{ DetallePuesto?.solicitud?.titulo_oferta }}
                </p>
                <p
                  :class="$vuetify.breakpoint.lgAndUp ? 'text-h6' : 'text-h6'"
                  class="text-secondary-color pt-0 ma-3 no-corte"
                >
                  Somete a concurso
                  {{
                    DetallePuesto?.oferta_bitacora[0]?.TipoConcurso?.nombre_concurso.toLowerCase()
                  }}
                </p>
                <!--                && this.Postulacion.hasOwnProperty('id_tipo_aplicacion') && this.Postulacion?.id_tipo_aplicacion !== 2-->

                <v-btn
                  :x-large="$vuetify.breakpoint.lgAndUp ? true : false"
                  color="bg-primary-color"
                  rounded
                  dark
                  width="205"
                  height="44"
                  style="
                    text-transform: none;
                    margin-bottom: 0.4cm;
                    margin-left: 14px;
                    margin-top: 2.5rem;
                  "
                  @click="abrirModal()"
                  v-if="
                    (this.Postulacion?.id_estado_oferta_persona === null ||
                    this.Postulacion?.id_estado_oferta_persona === undefined ||
                    (this.Postulacion?.id_tipo_aplicacion === 2 &&
                      this.Postulacion?.id_estado_oferta_persona === 9) ||
                    (this.Postulacion === null &&
                      this.Postulacion?.id_tipo_aplicacion !== 2)) && puedePostularse && validacionesTerminadas
                  "
                >
                  Postularme
                </v-btn>

                <div v-if="!puedePostularse && validacionesTerminadas" class="banner-alerta d-flex align-center pa-3 mt-8" style="margin-left: 14px; margin-right: 14px; margin-top: 2.5rem; margin-bottom: 1.5rem;">
                  <div class="icon-box-naranja mr-3 flex-shrink-0">
                    <v-icon color="white" small>mdi-alert-outline</v-icon>
                  </div>
                  <div class="alerta-descripcion">
                    {{ mensajeRestriccion }}
                  </div>
                </div>

                <v-chip
                  color="gray"
                  dark
                  width="205"
                  height="44"
                  v-if="
                    this.Postulacion?.id_tipo_aplicacion === 2 &&
                    this.Postulacion.id_estado_oferta_persona === 2
                  "
                >
                  <span class="ma-2" style="font-size: 1rem; margin-left: 14px"
                    >Invitación rechazada</span
                  >
                </v-chip>
                <v-chip
                  style="margin-left: 14px; margin-top: 1.25rem"
                  color="blue"
                  dark
                  width="205"
                  height="44"
                  v-if="
                    this.Postulacion?.id_estado_oferta_persona !== null &&
                    this.Postulacion?.id_estado_oferta_persona !== undefined &&
                    this.Postulacion.id_estado_oferta_persona === 3
                  "
                >
                  Postulación enviada
                </v-chip>
              </v-col>
            </v-row>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="6"
            class="mt-5 mt-sm-5 mb-0 pb-0 pr-md-10 pr-0 d-flex justify-center"
          >
            <v-img
              src="../../assets/img/detalle-empleo.png"
              style="width: 73.8%; max-width: 73.8%"
            ></v-img>
          </v-col>
        </v-row>
      </div>

      <!-- Inicia la descripcion de los puestos de trabajo -->
      <v-container>
        <v-row no-gutters class="mt-3 d-flex flex-column text-center">
          <h4 class="mb-3 text-h4 font-weight-bold" style="color: #1c1e4d">
            Descripción del puesto
          </h4>
          <p
            style="color: #616161; font-weight: 400"
            class="text-h6 text-sm-h5"
          >
            {{
              capitalizeFirstLetter(
                DetallePuesto?.solicitud?.MNTCargoFuncional?.descripcion
              )
            }}
          </p>
        </v-row>
      </v-container>
      <!-- Finaliza la descripcion de los puestos de trabajo -->

      <v-row class="mt-7 d-flex justify-center borde-requisitos">
        <h3 class="mb-3 text-h4 font-weight-bold" style="color: #1c1e4d">
          REQUISITOS
        </h3>
      </v-row>

      <v-row
        class="d-flex justify-center mt-4 px-0 mx-0 px-sm-6 mx-sm-6 px-md-10 mx-md-10"
      >
        <v-col cols="12" sm="6" class="texto-requisito col-mobile-center">
          <span style="color: #1c1e4d" class="texto-tamanio mx-5 mx-sm-0"
            ><strong>FORMACIÓN Y ESTUDIOS</strong></span
          >
          <template v-if="formacion.length > 0">
            <div
              class="d-flex flex-row text-start"
              v-for="(item, i) in formacion"
              :key="i"
            >
              <v-icon class="lista-icono ml-sm-2 ml-5" style="color: #616161"
                >mdi-circle</v-icon
              >
              <p class="py-0 my-0 mx-5 ml-1 texto-lista" v-if="item">
                {{ item }}
              </p>
            </div>
          </template>
          <div v-else class="d-flex flex-row text-start">
            <v-icon class="lista-icono ml-sm-2 ml-5" style="color: #616161"
              >mdi-circle</v-icon
            >
            <p class="py-0 my-0 mx-5 ml-1 texto-lista">
              No se requiere formación académica
            </p>
          </div>
        </v-col>

        <v-col cols="12" sm="6" class="pl-0 pl-sm-5 col-mobile-center">
          <span style="color: #1c1e4d" class="texto-tamanio mx-5 mx-sm-0"
            ><strong
              >CONOCIMIENTOS
              <strong :class="$vuetify.breakpoint.width < 349 ? 'ms-5' : 'ms-0'"
                >INDISPENSABLES</strong
              >
            </strong></span
          >
          <template v-if="conocimientosIndispensables.length > 0">
            <div
              class="d-flex flex-row text-start"
              v-for="(item2, i2) in conocimientosIndispensables"
              :key="i2"
            >
              <v-icon class="lista-icono ml-sm-2 ml-5" style="color: #616161"
                >mdi-circle</v-icon
              >
              <p class="py-0 my-0 mx-5 ml-1 texto-lista">{{ item2 }}</p>
            </div>
          </template>
          <div v-else class="d-flex flex-row text-start">
            <v-icon class="lista-icono ml-sm-2 ml-5" style="color: #616161"
              >mdi-circle</v-icon
            >
            <p class="py-0 my-0 mx-5 ml-1 texto-lista">
              No se requieren conocimientos indispensables
            </p>
          </div>
        </v-col>
      </v-row>

      <v-row
        class="d-flex justify-center justify-sm-start px-0 mx-0 px-sm-6 mx-sm-6 px-md-10 mx-md-10"
      >
        <v-col
          v-if="experienciasCapacidades.length > 0"
          cols="12"
          sm="6"
          class="texto-requisito col-mobile-center"
        >
          <span style="color: #1c1e4d" class="texto-tamanio mx-5 mx-sm-0"
            ><strong
              >HABILIDADES Y EXPERIENCIAS
              <strong :class="$vuetify.breakpoint.width < 349 ? 'ms-5' : 'ms-0'"
                >REQUERIDAS</strong
              >
            </strong></span
          >
          <div
            class="d-flex flex-row text-start"
            v-for="(item3, i3) in experienciasCapacidades"
            :key="i3"
          >
            <v-icon class="lista-icono ml-sm-2 ml-5" style="color: #616161"
              >mdi-circle</v-icon
            >
            <p class="py-0 my-0 mx-5 ml-1 texto-lista">{{ item3 }}</p>
          </div>
        </v-col>

        <v-col
          v-if="funciones.length > 0"
          cols="12"
          sm="6"
          :class="[
            funciones.length > 0
              ? (funciones.length === 0 ? '' : 'pl-sm-5 pl-0') +
                ' col-mobile-center'
              : ''
          ]"
        >
          <span style="color: #1c1e4d" class="texto-tamanio mx-5 mx-sm-0"
            ><strong>FUNCIONES</strong></span
          >
          <div
            class="d-flex flex-row text-start"
            v-for="(item4, i4) in funciones"
            :key="i4"
          >
            <v-icon class="lista-icono ml-sm-2 ml-5" style="color: #616161"
              >mdi-circle</v-icon
            >
            <p class="py-0 my-0 mx-5 ml-1 texto-lista">{{ item4 }}</p>
          </div>
        </v-col>
      </v-row>
      <v-row
        class="d-flex justify-center justify-sm-start px-0 mx-0 px-sm-6 mx-sm-6 px-md-10 mx-md-10"
      >
        <v-col
          cols="12"
          sm="6"
          class="texto-requisito col-mobile-center"
        >
          <span style="color: #1c1e4d" class="texto-tamanio mx-5 mx-sm-0"
            ><strong>REDES SOCIALES</strong></span
          >
          <div
            class="d-flex flex-row text-start"
          >
            <v-icon class="lista-icono ml-sm-2 ml-5" style="color: #616161"
              >mdi-circle</v-icon
            >
            <p class="py-0 my-0 mx-5 ml-1 texto-lista">{{ redesSociales ? 'Es requerido' : 'No es indispensable' }}</p>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          class="texto-requisito col-mobile-center"
        >
          <span style="color: #1c1e4d" class="texto-tamanio mx-5 mx-sm-0"
            ><strong>PRESTACIONES LABORALES</strong></span
          >
          <div
            class="d-flex flex-row text-start"
          >
            <div class="py-0 my-0 mx-5 ml-7 texto-lista" v-html="prestaciones"></div>
          </div>
        </v-col>
      </v-row>
      <v-row
        class="d-flex justify-center justify-sm-start px-0 mx-0 px-sm-6 mx-sm-6 px-md-10 mx-md-10"
      >
        <v-col
          cols="12"
          sm="6"
          class="texto-requisito col-mobile-center"
        >
          <span style="color: #1c1e4d" class="texto-tamanio mx-5 mx-sm-0"
            ><strong>JORNADA</strong></span
          >
          <div
            class="d-flex flex-row text-start"
          >
            <v-icon class="lista-icono ml-sm-2 ml-5" style="color: #616161"
              >mdi-circle</v-icon
            >
            <p class="py-0 my-0 mx-5 ml-1 texto-lista">{{ jornada }}</p>
          </div>
        </v-col>
        <v-col
          v-if="mostrarSalario"
          cols="12"
          sm="6"
          class="texto-requisito col-mobile-center"
        >
          <span style="color: #1c1e4d" class="texto-tamanio mx-5 mx-sm-0"
            ><strong>SALARIO</strong></span
          >
          <div
            class="d-flex flex-row text-start"
          >
            <v-icon class="lista-icono ml-sm-2 ml-5" style="color: #616161"
              >mdi-circle</v-icon
            >
            <p class="py-0 my-0 mx-5 ml-1 texto-lista">
              {{
                Intl.NumberFormat('es-US', {
                  style: 'currency',
                  currency: 'USD',
                }).format(salario)
              }}
            </p>
          </div>
        </v-col>
      </v-row>

      <v-row
        v-if="DetallePuesto?.serviciosProfesionales"
        class="d-flex justify-center justify-sm-start px-0 mx-0 px-sm-6 mx-sm-6 px-md-10 mx-md-10"
      >
        <v-col
          cols="12"
          sm="6"
          class="texto-requisito col-mobile-center"
        >
          <span style="color: #1c1e4d" class="texto-tamanio mx-5 mx-sm-0"
            ><strong>SISTEMA DE PAGO</strong></span
          >
          <div
            class="d-flex flex-row text-start"
          >
            <v-icon class="lista-icono ml-sm-2 ml-5" style="color: #616161"
              >mdi-circle</v-icon
            >
            <p class="py-0 my-0 mx-5 ml-1 texto-lista">{{ DetallePuesto?.solicitud?.tipoSolicitud?.SistemaPago?.nombre || '-' }}</p>
          </div>
        </v-col>
      </v-row>

      <v-row no-gutters class="d-flex justify-center align-center mt-16 mb-5">
        <v-btn
          color="bg-primary-color"
          dark
          rounded
          width="205"
          height="44"
          style="text-transform: none"
          @click="abrirModal()"
          v-if="
            (this.Postulacion?.id_estado_oferta_persona === null ||
            this.Postulacion?.id_estado_oferta_persona === undefined ||
            (this.Postulacion?.id_tipo_aplicacion === 2 &&
              this.Postulacion?.id_estado_oferta_persona === 9) ||
            (this.Postulacion === null &&
              this.Postulacion?.id_tipo_aplicacion !== 2)) && puedePostularse && validacionesTerminadas
          "
        >
          Postularme
        </v-btn>
      </v-row>
      <v-dialog v-model="modalAplicar" persistent max-width="600px">
        <v-card>
          <v-container>
            <v-row class="d-flex justify-center mt-9 mb-3 pl-2">
              <v-col cols="12 text-center">
                <span class="text-h5 text-primary-color-2"
                  ><b>¿Estás seguro de aplicar esta oferta de empleo?</b></span
                >
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center mb-3">
              <v-col cols="6" sm="3" class="d-flex justify-end">
                <v-btn
                  color="bg-primary-color"
                  outlined
                  rounded
                  @click="modalAplicar = false"
                  style="text-transform: none"
                  >Cancelar
                </v-btn>
              </v-col>
              <v-col cols="6" sm="3" class="d-flex justify-start">
                <v-btn
                  color="bg-primary-color"
                  rounded
                  @click="Postularse()"
                  dark
                  style="text-transform: none"
                  >Guardar
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="modalCompletarPerfil" persistent max-width="600px">
        <v-card>
          <v-container>
            <v-row class="d-flex justify-center mt-9 mb-3 pl-2">
              <v-col cols="12 text-center">
                <span class="text-h5 text-secondary-color"
                  ><b>Para postularte a esta oferta necesitas tener tu perfil completado al 100%</b></span
                >
              </v-col>
            </v-row>
            <v-row >
              <v-col cols="12" class="d-flex justify-center mb-3">
                <v-btn
                  color="bg-primary-color"
                  rounded
                  @click="completarPerfil()"
                  dark
                  style="text-transform: none"
                  >Completar perfil
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="modalRedesSociales" persistent max-width="600px">
        <v-card>
          <v-container>
            <v-row class="d-flex justify-center mt-9 mb-3 pl-2">
              <v-col cols="12 text-center">
                <span class="text-h5 text-secondary-color"
                  ><b>{{ messageRedes }}</b></span
                >
              </v-col>
            </v-row>
            <v-row >
              <v-col cols="12" class="d-flex justify-center mb-3">
                <v-btn
                  color="bg-primary-color"
                  rounded
                  @click="completarPerfil()"
                  dark
                  style="text-transform: none"
                  >Editar perfil
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="modalEmpleo" persistent max-width="600px">
        <v-card>
          <v-card-title class="d-flex justify-center">
            <v-icon color="#22234a" size="80">mdi-check-circle-outline</v-icon>
          </v-card-title>
          <v-card-text>
            <v-row class="d-flex justify-center mt-5 mb-3">
              <v-col cols="12">
                <span class="text-h4 text-secondary-color"
                  ><b>¡Te has postulado correctamente!</b></span
                >
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center mb-3">
              <v-col cols="6" sm="3">
                <v-btn
                  color="bg-primary-color"
                  dark
                  rounded
                  @click="cerrarModal()"
                  large
                  style="text-transform: none"
                >
                  Cerrar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <app-loader v-if="loading"></app-loader>
      <ModalRegistrarmeComponent
        :modal="modalRegistro"
        @cerrar="cerrarModalRegistro()"
      />
    </div>
  </div>
</template>
<script>
import Article from "../../components/Article.vue";
import AppLoader from "@/components/AppLoader.vue";
import { mapState } from "vuex";
import ModalRegistrarmeComponent from "../landingPage/components/modalRegistrarmeComponent.vue";
import AppFooter from "../../components/AppFooter.vue";
import ChatComponent from "../../components/ChatComponent.vue";

export default {
  name: "Detalle",
  components: {
    ModalRegistrarmeComponent,
    AppLoader,
    Article,
    AppFooter,
    ChatComponent
  },
  data() {
    return {
      Postulacion: null,
      DetallePuesto: null,
      modalAplicar: false,
      modalEmpleo: false,
      modalCompletarPerfil: false,
      modalRedesSociales: false,
      messageRedes: "",
      loading: false,
      modalRegistro: false,
      id_persona: false,
      dataLoaded: false,
      model: null,
      detallesOpcionesExtras: [],
      formacion: [],
      conocimientosIndispensables: [],
      conocimientos: [],
      competencias: [],
      aspectos: [],
      prestaciones: "",
      funciones: [],
      experienciasCapacidades: [],
      jornada: "",
      salario: 0,
      redesSociales: false,
      mostrarSalario: false,
      puedePostularse: true,
      mensajeRestriccion: null,
      validacionesTerminadas: false
    };
  },
  computed: {
    movil() {
      if (screen.width < 1024) {
        return false;
      } else {
        return true;
      }
    },
    ...mapState(["userInfo", "token"])
  },
  methods: {
    abrirModal() {
      if (!this.usuarioAutenticado()) {
        this.modalRegistro = true;
        return;
      }
      this.modalAplicar = true;
    },
    abrirAplicarEmpleo() {
      this.modalEmpleo = true;
    },
    cerrarModal() {
      this.modalAplicar = false;
      this.modalEmpleo = false;
    },

    async DetalleEmpleo() {
      let id_oferta = this.$router.history.current.params.id;
      try {
        const response = await this.services.OfertaEmpleo.getDetalleEmpleo(
          id_oferta
        );

        if (response.status == 200) {
          this.DetallePuesto = response.data;
          if (this.DetallePuesto?.solicitud?.DetalleOpcionExtras) {
            this.DetallePuesto.solicitud.DetalleOpcionExtras.forEach(
              (element) => {
                this.detallesOpcionesExtras.push(element);
              }
            );
          }
          if(this.DetallePuesto?.se_ofrece){
            this.prestaciones = this.DetallePuesto?.se_ofrece;
          }
          if(this.DetallePuesto?.jornada){
            this.jornada = this.DetallePuesto?.jornada;
          }
          if(this.DetallePuesto?.muestra_salario){
            this.mostrarSalario = this.DetallePuesto?.muestra_salario;
          }
          if(this.DetallePuesto?.solicitud?.salario_propuesto){
            this.salario = this.DetallePuesto?.solicitud?.salario_propuesto;
          }
        }
      } catch (e) {
      }
    },

    capitalizeFirstLetter(string) {
      if (!string) return "";

      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    async listRequisitos() {
      const idOferta = this.$router.history.current.params.id;

      const response = await this.services.OfertaEmpleo.getRequisitos(idOferta);
      if (response.status == 200) {
        this.conocimientosIndispensables = [];
        this.conocimientos = [];
        this.formacion = [];
        this.competencias = [];
        this.redesSociales = false;
        if (
          response.data.conocimientos &&
          response.data.conocimientos.length > 0
        ) {
          response.data.conocimientos.forEach((cono) => {
            if (cono.IndispensableConocimientoOferta.length > 0) {
              this.conocimientosIndispensables.push(
                this.capitalizeFirstLetter(cono.Conocimiento.nombre)
              );
            } else {
              this.conocimientos.push(
                this.capitalizeFirstLetter(cono.Conocimiento.nombre)
              );
            }
          });
        }
        if (
          response.data.conocimientos_extra &&
          response.data.conocimientos_extra.length > 0
        ) {
          response.data.conocimientos_extra.forEach((conoex) => {
            if (conoex.indispensable) {
              this.conocimientosIndispensables.push(
                this.capitalizeFirstLetter(conoex.nombre)
              );
            } else {
              this.conocimientos.push(
                this.capitalizeFirstLetter(conoex.nombre)
              );
            }
          });
        }
        if (response.data.formacion && response.data.formacion.length > 0) {
          response.data.formacion.forEach((formacion) => {
            this.formacion.push(
              this.capitalizeFirstLetter(formacion.FormacionEducativa.nombre)
            );
          });
        }
        if (
          response.data.formacion_extra &&
          response.data.formacion_extra.length > 0
        ) {
          response.data.formacion_extra.forEach((exfor) => {
            this.formacion.push(this.capitalizeFirstLetter(exfor.nombre));
          });
        }
        if (response.data.experiencias && response.data.experiencias.length > 0) {
          response.data.experiencias.forEach((exp) => {
            this.experienciasCapacidades.push(
              this.capitalizeFirstLetter(exp.experiencia)
            );
          });
        }
        if (response.data.capacidades && response.data.capacidades.length > 0) {
          response.data.capacidades.forEach((cap) => {
            this.experienciasCapacidades.push(
              this.capitalizeFirstLetter(cap.Capacidad.nombre)
            );
          });
        }
        if (response.data.aspectos && response.data.aspectos.length > 0) {
          response.data.aspectos.forEach((asp) => {
            this.competencias.push(
              this.capitalizeFirstLetter(asp.nombre_aspecto)
            );
          });
        }
        if (
          response.data.funciones &&
          response.data.funciones.length > 0
        ) {
          response.data.funciones.forEach((func) => {
            this.funciones.push(this.capitalizeFirstLetter(func.descripcion));
          });
        }
        if(response.data.requiere_redes_sociales){
          this.redesSociales = true;
        }
      }
    },

    async Postularse() {
      if (this.isTokenValido(this.token)) {
        let id_oferta = this.$router.history.current.params.id;
        try {
          this.loading = true;
          const response = await this.services.OfertaEmpleo.postPostularse(
            id_oferta,
            this.id_persona
          ).catch((e) => {
            if(e.response.data?.postulado === false){
              this.modalAplicar = false;
              this.modalCompletarPerfil = true;
              return
            }

            if(e.response.data?.redes_requeridas === true){
              this.modalAplicar = false;
              this.modalRedesSociales = true;
              this.messageRedes = e.response.data?.message
              return
            }

            this.temporalAlert({
              show: true,
              type: "error",
              message: "La oferta ya ha finalizado"
            });
            this.modalAplicar = false;
          });

          if (response.status == 200) {
            this.modalAplicar = false;
            this.temporalAlert({
              show: true,
              message: response.data.message,
              type: "success"
            });
            //.log("la persona se postulo correctamente",response.data.message)
          }
          await this.getValidacionPostulacion();
        } catch (e) {
        } finally {
          this.loading = false;
        }
      } else {
        this.temporalAlert({
          show: true,
          type: "error",
          message: "El token ya expiró, debe de volver a iniciar sesión"
        });
        this.$router.replace({ name: "login" });
      }
    },

    async getValidacionPostulacion() {
      let id_oferta = this.$router.history.current.params.id;
      try {
        const response = await this.services.OfertaEmpleo.getPostulacion(
          id_oferta,
          this.id_persona
        );
        if (response.status == 200) {
          this.Postulacion = response?.data[0];
        }
      } catch (e) {
      }
    },

    async validarRestricciones() {
      if (!this.token) return;
      try {
        let id_oferta = this.$router.history.current.params.id;
        const response = await this.services.OfertaEmpleo.getValidarPostulacion(id_oferta);
        if (response.status === 200 && response.data.puede_postularse === false) {
          this.puedePostularse = false;
          this.mensajeRestriccion = response.data.mensaje;
        }
      } catch (e) {
      }
    },

    regresar() {
      this.$router.back();
    },
    cerrarModalRegistro() {
      this.modalRegistro = false;
    },

    completarPerfil() {
      this.modalCompletarPerfil = false
      this.modalRedesSociales = false
      this.messageRedes = ""
      this.$router.push({ 
        name: "editar-perfil",  
        query: {
          from: "detalle-empleo",
          id: this.$route.params.id
        } 
      });
    }
  },

  async created() {
    this.loading = true;
    try {
      if (this.token) {
        this.id_persona = this.userInfo?.id_persona ?? this.userInfo?.id;
        await this.getValidacionPostulacion();
        await this.validarRestricciones();
      }
      await this.DetalleEmpleo();
      await this.listRequisitos();
      this.validacionesTerminadas = true;
    } catch (error) {
    } finally {
      this.dataLoaded = true;
      this.loading = false;
    }
  }
};
</script>
<style>
.museo-text {
  font-family: 'MuseoSans', sans-serif !important;
}

.bolder-text {
  -webkit-font-smoothing: antialiased;
  text-shadow: 0.2px 0 0 currentColor, -0.2px 0 0 currentColor;

}
@media only screen and (max-width: 600px) {
  .headline-1 {
    font-size: 2rem; /* Ajusta este valor según sea necesario par2a dispositivos móviles */
  }
}

.bg-primary-color {
  background-color: #22234a !important;
}

.text-primary-color {
  color: #22234a !important;
}

.text-primary-color-2{
  color: #1c1e4d !important;
}

.container-header-detalle {
  top: 0 !important;
  width: 100%;
  font-size: 12px;
  background: linear-gradient(90deg, #ffffff 0%, #f6f6f6 30%) !important;
  padding: 40px 20px !important;
  background-repeat: no-repeat !important;
  margin-bottom: 0;
}

.text-secondary-color {
  color: #263238;
}

.wave {
  background: url(../../assets/img/wave.svg);
  width: 100% !important;
  background-size: cover;
  padding-bottom: 160px;
}

.row-position {
  padding-top: 100px;
}
.borde-requisitos {
  border-bottom: 2px solid gray;
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0 20px;
}
.texto-requisito {
  padding-left: auto;
}

.texto-tamanio {
  font-size: 20px;
}

.lista-icono {
  font-size: 7px !important;
}

@media (max-width: 1440px) {
  .texto-requisito {
    padding-left: auto;
  }
  .texto-tamanio {
    font-size: 18px;
  }
  .componente-posicion {
    margin-left: 20px;
    margin-top: 100px;
  }
}

@media (max-width: 600px) {
  .texto-requisito,
  .col-mobile-center,
  .texto-tamanio {
    padding-left: 0 !important;
    text-align: start !important;
    font-size: 16px;
  }
  .texto-lista {
    font-size: 14px;
    color: #616161;
  }
  .borde-requisitos {
    width: 92%;
    margin-left: auto;
    padding: auto;
  }
  .posicionamiento-oferta {
    margin-top: 0;
  }
}
.texto-lista {
  font-size: 18px;
  color: #616161;
}
.v-list-item {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  text-align: start;
}
.icon-puesto {
  position: relative;
  top: 35px;
  left: 5%;
  transform: translate(-50%, -50%);
  background-color: #22234a;
  width: 4em;
  height: 4em;
  margin: 1rem;
}

.componente-posicion {
  margin-left: auto;
  margin-top: 70px;
}
/* .componente-posicion {
  margin-left: 150px;
  margin-top: 200px;
} */

.no-corte {
  white-space: normal;
}

.espaciadoLista {
  margin-bottom: 15px;
}

@media screen and (max-width: 600px) {
  .componente-posicion {
    margin-left: 20px;
    margin-top: 25px;
  }
}

.titulo {
  font-size: 2em !important;
}

@media (min-width: 600px) {
  .titulo {
    font-size: 3em !important;
  }
}

@media (min-width: 900px) {
  .titulo {
    font-size: 2em !important;
  }
}

@media (min-width: 1320px) {
  .titulo {
    font-size: 2em !important;
  }
}

@media (min-width: 1500px) {
  .titulo {
    font-size: 3.6em !important;
  }
}
@media (max-width: 1400px) {
  .responsiveDescriptionTitle {
    margin-left: 6px !important;
  }
}
.descriptionContainer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.descriptionRow {
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media (min-width: 768px) {
  .descriptionRow {
    flex-direction: row;
  }
}
.sizeLetter {
  font-size: 1.2rem;
}
@media (min-width: 768px) {
  .sizeLetter {
    font-size: 1.3rem;
  }
}
.padding-hero {
  padding-top: 0;
}

@media screen and (max-width: 800px) {
  .padding-hero {
    padding-top: 4rem;
  }
}

@media screen and (max-width: 460px) {
  .padding-hero {
    padding-top: 6rem;
  }
}

.banner-alerta {
  background-color: #fefbec;
  border-left: 6px solid #f1c235;
  border-radius: 8px;
  min-height: 90px !important;
}

.alerta-descripcion {
  color: #935828;
  font-size: 0.9rem;
  font-weight: 600;
}

.icon-box-naranja {
  background-color: #f1c235;
  border-radius: 8px;
  min-width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
